const api = {
  // BASE_API_URL: "http://127.0.0.1:8000/api/",
  BASE_API_URL: 'https://api-dev.korpazdravlja.ba/api/', // DEV
  IS_PRODUCTION: true,
}

export default api
